
import { defineComponent } from 'vue'
import { mapGetters, mapState } from 'vuex'
import AsahiProgress from '@/components/library/AsahiProgress.vue'
import AllertCart from '@/components/library/assets/AllertCart.vue'
import SuccessCart from '@/components/library/assets/SuccessCart.vue'
import formatDateMixin from '@/utils/mixin'

const HOMEPAGE_URL = '/'
const PDP_URL = 'productsDetail'
const PLP_URL = 'products'

export default defineComponent({
  components: { SuccessCart, AllertCart, AsahiProgress },
  mixins: [formatDateMixin],
  props: {
    changeMessageColor: {
      type: Boolean,
      default: false
    },
    messageType: {
      type: String,
      default: 'header'
    },
    mobile: {
      type: Boolean,
      default: false
    },
    isWhite: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('basket', ['id', 'query', 'items', 'paymentMethod']),
    ...mapGetters('basket', ['progressBarSuccess', 'showProgressBarMessage']),
    ...mapState('catalog', ['alignment', 'productFreeBeer']),

    isFreeBeerCheckActive (): boolean {
      return !!this.query?.free_beer_active
    },

    progressBar () {
      return this.query?.progress_bar_data
    },

    isHomePge () {
      return this.$route.path === HOMEPAGE_URL || this.$route.name === PDP_URL || this.$route.name === PLP_URL
    },
    maxOrderCash () {
      return this.progressBar?.iMaximumOrderCash ?? 0
    },
    grandTotalYourPrice () {
      return this.query?.grand_total_your_price_details?.grand_total_your_price ?? 0
    },
    cashFilledPercentage () {
      return (this.grandTotalYourPrice / this.maxOrderCash) * 100
    },
    differenceResult () {
      return Math.round(this.maxOrderCash - this.grandTotalYourPrice)
    },
    totalCartPallet () {
      return this.progressBar?.iTotalCartPalletQty ?? 0
    },
    minimumOrderPallett () {
      return this.progressBar?.iMinimumOrderPallet ?? 0
    },
    maximumOrderPallett () {
      return this.progressBar?.iMaximumOrderPallet ?? 0
    },

    messageColorClass () {
      console.log(this.progressBarMessage.color)
      if (this.changeMessageColor) {
        if (this.progressBarMessage.color === 'red') {
          return 'border-error-text'
        } else if (this.progressBarMessage.color === 'green') {
          return 'border-success-text'
        } else if (this.progressBarMessage.color === 'yellow') {
          return 'border-info-text'
        } else if (this.progressBarMessage.color === 'orange') {
          return 'border-alert-text'
        } else {
          return 'border-default-text'
        }
      }
      return 'border-default-text'
    },

    isCompactAndFullTruck () {
      return this.messageType === 'compact'
    },
    isMsgColor () {
      if (this.progressBar?.color === 'green') {
        return 'msg-color-green'
      } else if (this.progressBar?.color === 'yellow') {
        return 'msg-color-yellow'
      } else if (this.progressBar?.color === 'orange') {
        return 'msg-color-orange'
      } else {
        return 'msg-color-error'
      }
    },

    progressBarMessage () {
      if (this.progressBar?.isFullTruck ||
          this.progressBar?.isHalfTruck ||
          this.progressBar?.isSmallOrder) {
        if (this.progressBar?.status === 7) {
          return {
            title: this.$t('THE NUMBER OF 1PLN PALLETS EXCEEDS THE TRUCK CAPACITY.'),
            subtitle: this.$t('THE NUMBER OF 1PLN PALLETS EXCEEDS THE TRUCK CAPACITY.'),
            buttonTitle: this.$t('Update'),
            hasError: true,
            hasSucccess: false,
            color: 'red'
          }
        } else if ((this.progressBar?.iTotalCartWeight > 0 &&
             this.progressBar?.iTotalCartWeight < this.progressBar?.iMinimumOrderWeight) ||
             (this.progressBar?.iTotalCartPalletQty > 0 &&
             this.progressBar?.iTotalCartPalletQty < this.progressBar?.iMinimumOrderPallet)
        ) {
          return {
            title: this.$t('LOGISTICAL MINIMUM OF THE ORDER HAS NOT BEEN REACHED. ORDER MORE PRODUCTS.'),
            subtitle: this.$t('LOGISTICAL MINIMUM OF THE ORDER HAS NOT BEEN REACHED. ORDER MORE PRODUCTS.'),
            buttonTitle: this.$t('Update'),
            hasError: true,
            hasSucccess: false,
            color: 'red'
          }
        } else if (this.progressBar?.iTotalCartWeight > 0 &&
            this.progressBar?.iTotalCartWeight > this.progressBar?.iMaximumOrderWeight) {
          return {
            title: `${this.$t('THE WEIGHT OF THE ORDER HAS BEEN EXCEEDED:')} <b>${this.progressBar?.iTotalCartWeight}Kg / ${this.progressBar?.iMaximumOrderWeight}Kg</b>`,
            subtitle: this.$t('THE WEIGHT OF THE ORDER HAS BEEN EXCEEDED'),
            buttonTitle: this.$t('Update'),
            hasError: true,
            hasSucccess: false,
            color: 'red'
          }
        } else if (this.progressBar?.iTotalCartPalletQty > 0 &&
            this.progressBar?.iTotalCartPalletQty > this.progressBar?.iMaximumOrderPallet) {
          return {
            title: `${this.$t('THE NUMBER OF PALLETS HAS BEEN EXCEEDED:')} <b>${this.progressBar?.iTotalCartPalletQty} / ${this.progressBar?.iMaximumOrderPallet}</b>`,
            subtitle: this.$t('THE NUMBER OF PALLETS HAS BEEN EXCEEDED'),
            buttonTitle: this.$t('Update'),
            hasError: true,
            hasSucccess: false,
            color: 'red'
          }
        } else if (this.progressBar?.iTotalCartWeight > 0 &&
            (this.progressBar?.iTotalCartWeight >= this.progressBar?.iMinimumOrderWeight &&
            this.progressBar?.iTotalCartWeight <= this.progressBar?.iMaximumOrderWeight) &&
            (this.progressBar?.iTotalCartPalletQty >= this.progressBar?.iMinimumOrderPallet &&
            this.progressBar?.iTotalCartPalletQty <= this.progressBar?.iMaximumOrderPallet)

        ) {
          if (this.progressBar?.iTotalCartWeight >= this.progressBar?.iMinimumOrderWeight &&
              this.progressBar?.iTotalCartWeight <= this.progressBar?.iMaximumOrderWeight &&
              this.progressBar?.iTotalCartPalletQty >= this.progressBar?.iMinimumOrderPallet &&
              this.progressBar?.iTotalCartPalletQty < this.progressBar?.iNintyOrderPallet
          ) {
            return {
              title: this.$t('THE LOGISTICAL MINIMUM OF THE ORDER HAS BEEN REACHED'),
              subtitle: this.$t('THE LOGISTICAL MINIMUM OF THE ORDER HAS BEEN REACHED'),
              buttonTitle: this.$t('Update price'),
              hasError: false,
              hasSucccess: true,
              color: 'yellow'
            }
          } else if (this.progressBar?.iTotalCartWeight >= this.progressBar?.iMinimumOrderWeight &&
              this.progressBar?.iTotalCartWeight <= this.progressBar?.iMaximumOrderWeight &&
              this.progressBar?.iTotalCartPalletQty >= this.progressBar?.iNintyOrderPallet &&
              this.progressBar?.iTotalCartPalletQty < this.progressBar?.iMaximumOrderPallet
          ) {
            return {
              title: this.$t('THE LOGISTICAL MINIMUM OF THE ORDER HAS BEEN REACHED'),
              subtitle: this.$t('THE LOGISTICAL MINIMUM OF THE ORDER HAS BEEN REACHED'),
              buttonTitle: this.$t('Update price'),
              hasError: false,
              hasSucccess: true,
              color: 'orange'
            }
          } else {
            return {
              title: this.$t('THE LOGISTICAL MINIMUM OF THE ORDER HAS BEEN REACHED'),
              subtitle: this.$t('THE LOGISTICAL MINIMUM OF THE ORDER HAS BEEN REACHED'),
              buttonTitle: this.$t('Update price'),
              hasError: false,
              hasSucccess: true,
              color: 'green'
            }
          }
        } else if (this.progressBar?.iTotalCartWeight < 1) {
          return {
            title: this.$t('LOGISTICAL MINIMUM OF THE ORDER HAS NOT BEEN REACHED. ORDER MORE PRODUCTS.'),
            subtitle: this.$t('LOGISTICAL MINIMUM OF THE ORDER HAS NOT BEEN REACHED. ORDER MORE PRODUCTS.'),
            buttonTitle: this.$t('Update price'),
            hasError: false,
            hasSucccess: false,
            color: 'red'
          }
        }
      }
      return { title: '', subtitle: '' }
    },
    progressBarMiniMessage () {
      if (this.progressBar?.isFullTruck ||
          this.progressBar?.isHalfTruck ||
          this.progressBar?.isSmallOrder) {
        if (this.progressBar?.status === 7) {
          return {
            title: `<b>${this.progressBar?.iTotalCartPalletQty} / ${this.progressBar?.iMaximumOrderPallet} ${this.$t('Pallet')}</b>`,
            hasError: true,
            hasSucccess: false
          }
        } else if (this.progressBar?.iTotalCartWeight > 0 &&
            this.progressBar?.iTotalCartWeight < this.progressBar?.iMinimumOrderWeight) {
          return {
            title: `<b>${this.progressBar?.iTotalCartWeight}Kg / ${this.progressBar?.iMinimumOrderWeight}Kg</b>`,
            hasError: true,
            hasSucccess: false
          }
        } else if (this.progressBar?.iTotalCartWeight > 0 &&
            this.progressBar?.iTotalCartWeight > this.progressBar?.iMaximumOrderWeight) {
          return {
            title: `<b>${this.progressBar?.iTotalCartWeight}Kg / ${this.progressBar?.iMaximumOrderWeight}Kg</b>`,
            hasError: true,
            hasSucccess: false
          }
        } else if (this.progressBar?.iTotalCartPalletQty > 0 &&
            this.progressBar?.iTotalCartPalletQty > this.progressBar?.iMaximumOrderPallet) {
          return {
            title: `<b>${this.progressBar?.iTotalCartPalletQty} / ${this.progressBar?.iMaximumOrderPallet} ${this.$t('Pallet')}</b>`,
            hasError: true,
            hasSucccess: false
          }
        } else if (this.progressBar?.status !== 7 &&
            this.progressBar?.iTotalCartWeight > 0 &&
            (this.progressBar?.iTotalCartWeight >= this.progressBar?.iMinimumOrderWeight &&
            this.progressBar?.iTotalCartWeight <= this.progressBar?.iMaximumOrderWeight) &&
            (this.progressBar?.iTotalCartPalletQty >= this.progressBar?.iMinimumOrderPallet &&
            this.progressBar?.iTotalCartPalletQty <= this.progressBar?.iMaximumOrderPallet)
        ) {
          return {
            title: this.$t('THE LOGISTICAL MINIMUM OF THE ORDER HAS BEEN REACHED'),
            subtitle: this.$t('THE LOGISTICAL MINIMUM OF THE ORDER HAS BEEN REACHED'),
            hasError: false,
            hasSucccess: true
          }
        }
      }
      return { title: '', subtitle: '' }
    }

  },
  data () {
    return {
      errorWeight: false,
      successWeight: false,
      isComponentVisible: false,
      errorWeightBar: false,
      isMobile: (window.innerWidth <= 768) || (this.messageType === 'mobile'),
      isSmallDevice: window.innerWidth < 1024
    }
  },
  methods: {
    getFillPercentage () {
      let fillPercentage = 0
      if (!this.progressBar?.isFullTruck && !this.progressBar?.isHalfTruck && !this.progressBar?.isSmallOrder) {
        fillPercentage = this.progressBar?.iTotalCartWeight / this.progressBar?.iMaximumOrderWeight * 100
      } else {
        const currentValue = this.progressBarMessage?.hasSucccess ? this.progressBar?.iMaximumOrderWeight : this.progressBar?.iTotalCartWeight
        fillPercentage = currentValue / this.progressBar?.iMaximumOrderWeight * 100
      }
      this.emitRequirementStatus()
      return fillPercentage
    },
    emitRequirementStatus () {
      const requirementMessage = this.progressBarMessage
      this.$emit('requirement-status', requirementMessage)
    }
  }
})
